{
  "#KINOABFRAGE": {
    "APP": "Kinoabfrage",
    "TITLE": "Kinoabfrage",
    "COMPONENTS": {
      "KINOLIST": {
        "TITLE": "Kinoliste"
      },
      "QUERY": {
        "TITLE": "Statistik",
        "QUERY": "Suche"
      },
      "RESULT": {
        "RESERVED": "Reserviert",
        "SOLD": "Verkauft",
        "TOTAL": "Gesamt"
      }
    }
  }
}